module.exports = __webpack_public_path__ + "6bad9f5013e824ecc1d4168afd0305e7.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/left.png
// module id = 685
// module chunks = 0